import { FC } from "react";
import style from "../pdf-style.module.scss";
import cx from "classnames";

interface SecurityDetails {
  totalLoan: string;
  deposit: string;
  lvr: string;
}

const TableDetails: FC<{
  title: string;
  data: Array<any>;
  noSpaceBottom?: boolean;
  addSpaceTop?: boolean;
  isLoanDetails?: boolean;
  isSecurityDetails?: boolean;
  securityDetails?: SecurityDetails;
  lendingAction?: string;
}> = (props) => {
  return (
    <table
      className={cx(style["table-details"], style["table"])}
      style={{
        marginBottom: props?.noSpaceBottom ? "" : "20px",
        marginTop: props?.isLoanDetails
          ? "5px"
          : props?.addSpaceTop
          ? "20px"
          : "",
      }}
    >
      <tbody>
        <tr className={style["table-details-header"]}>
          <td
            className={style["table-details-head"]}
            align="left"
            colSpan={props?.isSecurityDetails ? 1 : 2}
            style={{
              backgroundColor: props?.isLoanDetails ? "#ECECEC" : "#1d1c1d",
            }}
          >
            <p className={style[props?.isLoanDetails ? "title-loan" : "title"]}>
              {props.title}
              {props?.lendingAction && (
                <span className={style["badge-lending"]}>
                  {props?.lendingAction}
                </span>
              )}
            </p>
          </td>
          {props?.isSecurityDetails && (
            <td className={style["table-details-head-loan"]} align="left">
              <div className={style["loan-wrapper"]}>
                <span className={style["amount"]}>
                  Total Loan:
                  <span style={{ color: "#579bcb", marginLeft: "5px" }}>
                    {props?.securityDetails?.totalLoan}
                  </span>
                </span>
                <span className={style["amount"]}>
                  Deposit:
                  <span style={{ color: "#579bcb", marginLeft: "5px" }}>
                    {props?.securityDetails?.deposit}
                  </span>
                </span>
                <span className={style["amount"]}>
                  LVR:
                  <span style={{ color: "#579bcb", marginLeft: "5px" }}>
                    {props?.securityDetails?.lvr}
                  </span>
                </span>
              </div>
            </td>
          )}
        </tr>
        {props.data.map((_item, idx) => (
          <tr key={idx}>
            <td align="left" style={{ backgroundColor: "#f6f6f6" }}>
              <p>{_item.title}</p>
            </td>
            <td align="left" style={{ paddingLeft: "20px" }}>
              <p>{_item.value}</p>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableDetails;
